export default "__VITE_ASSET__Dxi7vrvX__"